import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { pauseChargingService } from '../../api/charging-service.ts';

export default function usePauseChargingService(): UseMutationResult<
  Awaited<ReturnType<typeof pauseChargingService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => pauseChargingService(serviceId),
  });
}
